<template>
  <div class="container-fluid">
    <div class="card border-0">
      <div class="card-body">
        <h5 class="card-title">
          <div class="project">{{ projectName }}</div>
          <div class="time">{{ timeFrame }}</div>
        </h5>
        <br>
        <ul>
          <li v-for="(feature, index) in features" :key="index">{{ feature }}</li>
        </ul>
        <br>
        <div class="skill">
          <b-badge
            pill
            variant="secondary"
            v-for="(skill, index) in skills"
            :key="index"
          >{{ skill }}</b-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Project",
  props: ["projectInfo"],
  data() {
    return {
      projectName: this.projectInfo.projectName,
      timeFrame: this.projectInfo.timeFrame,
      features: this.projectInfo.features,
      skills: this.projectInfo.skills,
    };
  },
};
</script>

<style scoped>
.project {
  font-weight: bold;
  display: block;
  color: #f05e25;
  margin: 0;
  float: left;
  font-size: 1.2em;
  clear: both;
}
.container-fluid {
  margin-bottom: 10px;
  padding: 0;
}
li {
  font-size: 0.8em;
  float: left;
  clear: both;
  text-align: left;
}
li:before {
  content: "\25b8 ";
}
.skill {
  float: left;
  clear: both;
  margin-top: 5px;
}
.skill > * {
  margin-right: 8px;
}
.time {
  float: right;
  font-size: 0.9em;
  font-family: "Catamaran", sans-serif;
}
</style>
